const manageAdminProfileConstantsEn = {
  manageAdminProfileHederTitle: 'Edit',
  manageAdminProfileBackButton: 'Back',
  manageAdminProfileRoleOption1: 'Admin',
  manageAdminProfileRoleOption2: 'Data Entry',
  manageAdminProfileSubtitle1: 'User Info',
  manageAdminProfileSubtitle2: 'User Role',
  manageAdminProfileSubtitle3: 'Change Password',
  manageAdminProfileEmailLabel: 'User Email',
  manageAdminProfileFirstNameLabel: 'First Name',
  manageAdminProfileLastNameLabel: 'Last Name',
  manageAdminProfilePhoneLabel: 'Phone Number',
  manageAdminProfileJobTitleLabel: 'Job Title',
  manageAdminProfileChangePasswordButton: 'Change Password',
  manageAdminProfileSaveButton: 'Save',
  changePasswordDialogTitle: 'Change Password',
  changePasswordDialogOldPasswordLabel: 'Old Password',
  changePasswordDialogNewPasswordLabel: 'New Password',
  changePasswordDialogConfirmPasswordLabel: 'Confirm Password',
  changePasswordDialogSendOtpButton: 'Send Verification Code',
  changePasswordDialogOldPasswordEmptyInputError: 'Old Password is required',
  changePasswordDialogOldPasswordWrongError: 'Old Password is wrong',
  changePasswordDialogNewPasswordEmptyInputError: 'New Password is required',
  changePasswordDialogConfirmPasswordError: 'Password does not match',
  changePasswordDialogNewPasswordSameAsOldError: 'New Password cannot be same as Old Password',
  requiredField: 'This field is required',
};

export default manageAdminProfileConstantsEn;
